import React from "react";
import { FaPlus, FaTimes, FaComments, FaCommentAlt } from "react-icons/fa";

const formatRelativeTime = (dateString) => {
    if (!dateString) return "";
    const diffMs = Date.now() - new Date(dateString).getTime();
    const mins = Math.floor(diffMs / 60000);
    if (mins < 1) return "just now";
    if (mins < 60) return `${mins}m ago`;
    const hours = Math.floor(mins / 60);
    if (hours < 24) return `${hours}h ago`;
    return `${Math.floor(hours / 24)}d ago`;
};

const ChatSidebar = ({ chats, activeChatId, onSelectChat, onNewChat, isOpen, onClose }) => (
    <>
        {isOpen && <div className="fixed inset-0 bg-black/30 z-30 lg:hidden" onClick={onClose} />}
        <aside
            className={`absolute lg:static inset-y-0 lg:inset-y-auto left-0 lg:left-auto z-40 w-72 lg:my-5 lg:ml-5
                bg-white border-r border-gray-100 lg:border lg:rounded-2xl lg:shadow-sm
                flex flex-col transform transition-transform duration-200 ${
                    isOpen ? "translate-x-0" : "-translate-x-full"
                } lg:translate-x-0`}
        >
            <div className="p-4 flex items-center justify-between border-b border-gray-100">
                <h2 className="font-semibold text-gray-700 flex items-center gap-2 text-sm">
                    <FaComments className="text-[#2148C0]" /> Chats
                </h2>
                <button onClick={onClose} className="lg:hidden text-gray-400">
                    <FaTimes />
                </button>
            </div>
            <div className="p-3">
                <button
                    onClick={onNewChat}
                    className="w-full flex items-center justify-center gap-2 bg-[#2148C0] text-white rounded-full py-2.5 text-sm font-medium shadow-sm hover:opacity-90 transition"
                >
                    <FaPlus size={12} /> New Chat
                </button>
            </div>
            <div className="flex-1 overflow-y-auto px-2 pb-4 space-y-1">
                {chats.length === 0 && (
                    <div className="text-center mt-8 px-4">
                        <div className="w-10 h-10 rounded-xl bg-gray-50 flex items-center justify-center mx-auto mb-2">
                            <FaCommentAlt className="text-gray-300" size={14} />
                        </div>
                        <p className="text-xs text-gray-400">No chats yet — start one above.</p>
                    </div>
                )}
                {chats.map((chat) => (
                    <button
                        key={chat.id}
                        onClick={() => onSelectChat(chat.id)}
                        className={`w-full text-left px-3 py-2.5 rounded-xl transition ${
                            chat.id === activeChatId ? "bg-blue-50 border border-[#2148C0]/30" : "hover:bg-gray-50 border border-transparent"
                        }`}
                    >
                        <p className={`text-sm truncate ${chat.id === activeChatId ? "font-semibold text-[#2148C0]" : "font-medium text-gray-800"}`}>
                            {chat.title}
                        </p>
                        <div className="flex items-center justify-between mt-0.5 gap-2">
                            <p className="text-xs text-gray-400 truncate flex-1">{chat.lastMessage || "No messages yet"}</p>
                            <span className="text-[10px] text-gray-400 shrink-0">{formatRelativeTime(chat.lastMessageAt)}</span>
                        </div>
                    </button>
                ))}
            </div>
        </aside>
    </>
);

export default ChatSidebar;
